import axios from "axios";
import { selectHelper } from "./selectHelper";

function getActiviteBySecteurActivite(secteurActiviteId) {
    const $select = $("#activiteId, #activite_id");
    
    selectHelper($select, 1);

    if (secteurActiviteId !== "") {
        selectHelper($select, 2);

        axios.post(
            route("activite-by-secteur",{ secteurActiviteId: secteurActiviteId })
        )
        .then((response) => {
            selectHelper($select, 3);

            response.data.forEach(item => {
                $select.append(`<option value="${item.id}">${item.label}</option>`);
            });

            selectHelper($select, 4);
        })
        .catch((error) => {
            selectHelper($select, 4);
            console.error("Erreur lors de la récupération des activités :", error);
        });
    } else {
        $select.append("<option value=''>Séléctionnez</option>");
    }
}


function handleClientByMode(mode) {
    // masquer le champ prénoms si le champ Mode est "Structure".
    // masquer le champ sigle si le mode est "PARTICULIER"
    if (mode === enums.Mode.STRUCTURE) {
        $("#firstnames").parent().hide();
        $("#sigle").parent().show();
    } else {
        $("#firstnames").parent().show();
        $("#sigle").parent().hide();
    }
}



$(document).ready(function() {
    // Gestion du changement de secteur d'activité
    const mode =  $("#mode").val();
    handleClientByMode(mode);

    $("#mode").change(function() {
        handleClientByMode(this.value);
    });

    $("#secteurActiviteId, #secteur_activite_id").change(function() {
        getActiviteBySecteurActivite(this.value);
    });

    // modifier telephone_for_auth avec le telephone1:
    $("#telephone1").on('change',function(){
        $("#telephone_for_auth").val($(this).val())  
    })

    // Event delegation pour tous les boutons de toggle password
    $(document).on('click', '.password-toggle', function() {
        const fieldId = $(this).siblings('input[type="password"], input[type="text"]').attr('id');
        const $passwordField = $('#' + fieldId);
        const $toggleIcon = $(this).find('i');
        
        const isPassword = $passwordField.attr('type') === 'password';
        
        $passwordField.attr('type', isPassword ? 'text' : 'password');
        $toggleIcon.toggleClass('fa-eye fa-eye-slash');
    });
})